/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { connect } from "react-redux";
import { setLanguage } from "actions";
import "components/widgets/language/language.css";
import { ReactComponent as TrFlag } from "components/widgets/language/icon-lang-turkish.svg";
import { ReactComponent as EnFlag } from "components/widgets/language/icon-lang-english.svg";

class LanguageSelector extends Component {
  componentDidMount() {
    if (!this.props.language) {
      let lang = localStorage.getItem("i18nextLng")
        ? localStorage.getItem("i18nextLng")
        : "tr-TR";

      this.props.setLanguage(lang);
    }
  }

  changeLanguage = (lang) => {
    this.props.setLanguage(lang);
    window.location.reload();
  };

  getLanguage = () => {
    switch (this.props.language) {
      case "tr-TR":
        return "TUR";
      case "en-US":
        return "ENG";
      default:
        return "TUR";
    }
  };
  render() {
    return (
      <li className="lang d-none d-md-block d-lg-block">
        <a href="#">{this.getLanguage()}</a>
        <ul>
          <li>
            <a href="#" onClick={() => this.changeLanguage("tr-TR")}>
              <TrFlag className="img-fluid flag" /> Türkçe
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("en-US")}>
              <EnFlag className="img-fluid flag" /> English
            </a>
          </li>
        </ul>
      </li>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.application.language,
  };
};

export default connect(mapStateToProps, { setLanguage })(LanguageSelector);
